// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - Onboarding Component
// ═══════════════════════════════════════════════════════════════════════════

import { PROMPTS } from '../config/prompts.js';
import { setOnboardingComplete } from '../services/storage.js';

export function createOnboarding(onComplete) {
    let currentSlide = 0;
    const slides = PROMPTS.onboarding;

    const overlay = document.createElement('div');
    overlay.className = 'onboarding-overlay';

    function render() {
        const slide = slides[currentSlide];
        const isLast = currentSlide === slides.length - 1;

        overlay.innerHTML = `
      <div class="onboarding-slide">
        <h1 class="onboarding-title">${slide.title}</h1>
        <p class="onboarding-text">${slide.text}</p>
        ${slide.hint ? `<p class="onboarding-hint">${slide.hint}</p>` : ''}
        
        <div class="onboarding-dots">
          ${slides.map((_, i) => `
            <div class="onboarding-dot ${i === currentSlide ? 'active' : ''}"></div>
          `).join('')}
        </div>
        
        <button class="onboarding-btn">${isLast ? 'Begin' : 'Continue'}</button>
      </div>
    `;

        // Add click handler
        const btn = overlay.querySelector('.onboarding-btn');
        btn.addEventListener('click', handleNext);

        // Also allow tapping anywhere to proceed
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) handleNext();
        });
    }

    function handleNext() {
        if (currentSlide < slides.length - 1) {
            currentSlide++;
            render();
        } else {
            // Complete onboarding
            setOnboardingComplete();
            overlay.classList.add('fade-out');
            setTimeout(() => {
                overlay.remove();
                if (onComplete) onComplete();
            }, 300);
        }
    }

    render();
    return overlay;
}

export default createOnboarding;
